// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Highscore from "./highscore.js"
import HighscoreGenerationSurvey from "./highscore-generation-survey.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "highscore_id": {
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": false,
        "type": "uuid"
      },
      "name": "highscore_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "HighscoreGeneration",
  "collectionKey": "highscore_generations",
  "collectionName": "highscore_generations",
  "i18nKey": "highscore_generation",
  "camelizedLower": "highscoreGeneration",
  "name": "HighscoreGeneration",
  "nameDasherized": "highscore-generation",
  "pluralName": "highscore_generations",
  "ransackable_associations": [
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "highscore_generation_id",
      "name": "highscore_generation_surveys",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    },
    {
      "className": "HighscoreGenerationTeam",
      "collectionName": "highscore_generation_teams",
      "foreignKey": "highscore_generation_survey_id",
      "name": "highscore_generation_teams",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationTeam",
      "through": "highscore_generation_surveys"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": "teams"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": "highscore_generation_teams"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highscore_id",
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_highscore_id",
      "column": {
        "default": null,
        "name": "old_highscore_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "highscore_generation_id",
      "name": "highscore_generation_surveys",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    }
  ],
  "paramKey": "highscore_generation",
  "primaryKey": "id"
}

/** Frontend model for HighscoreGeneration. */
export default class HighscoreGeneration extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  highscoreId() {
    return this.readAttributeUnderscore("highscore_id")
  }

  /** @returns {boolean} */
  hasHighscoreId() {
    const value = this.highscoreId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  exportParticipantsCsv(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "export_participants_csv",
        primaryKey: this.primaryKey(),
        collectionName: "highscore_generations",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  exportOverallCsv(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "export_overall_csv",
        primaryKey: this.primaryKey(),
        collectionName: "highscore_generations",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  participants(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "participants",
        primaryKey: this.primaryKey(),
        collectionName: "highscore_generations",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./highscore.js").default | null} */
  highscore() {
    return this._readBelongsToReflection({modelClass: Highscore, reflectionName: "highscore"})
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  loadHighscore() {
    if (!("highscoreId" in this)) throw new Error("Foreign key method wasn't defined: highscoreId")

    const id = this.highscoreId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "highscore",
        model: this,
        modelClass: Highscore
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  ensureHighscoreLoaded() {
    return this.ensureAssociationLoaded("highscore")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-generation-survey.js").default>} */
  highscoreGenerationSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_generation_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_generation_surveys",
        model: this,
        modelClass: HighscoreGenerationSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation-survey.js").default>>} */
  loadHighscoreGenerationSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_generation_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_generation_surveys",
        model: this,
        modelClass: HighscoreGenerationSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation-survey.js").default>>} */
  ensureHighscoreGenerationSurveysLoaded() {
    return this.ensureAssociationLoaded("highscore_generation_surveys")
  }
}
